<template>
  <div id="app" ref="homePage">
    <Nav v-if="!isTracePage" />

    <router-view ></router-view>

    <Footer v-if="!isTracePage" />
  </div>
</template>

<script>
  import Nav from "./Nav";
  import Footer from "./Footer";
  export default {
    name: "App",
    components: {
      Nav,
      Footer
    },
    data() {
      return {
        scrollVal:""
      }
    },
    computed: {
      // 判断是否是溯源查询页面
      isTracePage() {
        return this.$route.path.startsWith('/trace')
      }
    },
    mounted() {
      window.addEventListener("scroll", this.handleScroll);
    },

    watch: {
      scrollVal: function (newVal) {
        this.scrollVal = newVal;
      },
    },
    methods: {
      changeFixed(clientHeight) {                        //动态修改样式
        this.$refs.homePage.style.height = clientHeight + 'px';
      },
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (  scrollTop > 560) {
          if(this.scrollVal > scrollTop){
            this.$('.gmp-header').removeClass('h-is-wholly-scrolled')
          }else{
            this.$('.gmp-header').addClass('h-is-wholly-scrolled')
          }
        }
        else {
          this.$('.gmp-header').removeClass('h-is-wholly-scrolled')
        }
        this.scrollVal = scrollTop;

      },
    }

  }
</script>

<style lang="less">

  #app {
    height: 100%;
  }

</style>
